<template>
  <div id="app">
    <NotificationContainer />
    <AppLoading v-if="loader.blockingLoader" />
    <PaymentReceivedModal />
    <router-view />
  </div>
</template>
<script>
import { mapState } from "vuex";
import NotificationContainer from "./components/Utility/NotificationContainer";
import AppLoading from "./components/AppComponents/AppLoading";
import PaymentReceivedModal from "./components/Modal/PaymentReceivedModal";

export default {
  name: "App",
  components: { PaymentReceivedModal, NotificationContainer, AppLoading },
  computed: {
    ...mapState(["loader"])
  },
  created() {
    this.$store.dispatch("organization/getAllOrganizations", null, {
      root: true
    });
    this.$store.dispatch("donation/getDonationsStats", null, { root: true });
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
a {
  cursor: pointer;
}
</style>
